import { FilterState, FilterType } from '../ngx-table-column-filter/ngx-table-column-filter.models';
import { BusinessCompGuide } from '../templates/business-comp-guide/business-comp-guide.component';
import { ActivitySubTypeEnum } from './activity-type.enum';

export const MENU_CONSTANTS = {
    HELP: 'help',
    SETTINGS: 'settings',
    USERMENU: 'user menu',
    SUPPORT: 'contact support team'
};

export const File_TYPE = {
    EMPLOYEE: 1,
    PROJECT: 2,
    EXPENSEDATA: 3,
    TIMETRACKING: 4,
    EXPENSE_SURVEY: 5,
    TIME_SURVEY: 6,
    CLIENT_USER: 7,
    PREPARED_BY_CLIENT: 8,
    AGILE_ANALYZER: 9,
    SURVEY_COMPLETE_INSTRUCTIONS: 10,
    EXPENSE_DATA_MAP_ERROR: 11,
    PROJECT_SURVEY: 6,
    RELEASE_NOTES: 12,
    RELEASE_HISTORY: 13,
    MEMO_GENERATOR: 14,
    BUSINESS_COMPONENT: 15
};

export const SURVEY_CATEGORY_TYPE = {
    TIME_SURVEY: 0,
    EXPENSE_SURVEY: 1,
    PROJECT_SURVEY: 2
}

export const SUPPORTED_FILE_TYPE = {
    UPLOAD: '.xls,.xlsx',
    ATTACHMENT: '.html,.htm,.ppt,.pptx,.txt,.doc,.docx,.pdf,.msg,.zip,.eml,.odt,.rtf,.xls,.xlsx,.xlsm,.csv',
    INSTRUCTIONS_UPLOAD: '.pdf,.xlsx'
}

export const APP_CONSTANTS = {
    STUDY_ID: 'studyId',
    SURVEY_ID: 'surveyId',
    ENGAGEMENT_ID: 'engagementId',
    FILE_TYPE: 'fileType',
    DRAG_AND_DROP_HERE: 'Drag & drop here',
    CREATE_SURVEYS: 'Create Surveys',
    AMOUNT: 'Amount',
    SME: 'SME',
    COST_CENTER: 'Cost Center',
    PROJECT: 'Project',
    QRE_TYPE: 'QRE Type',
    LOCATION: 'Location',
    SUCCESS: 'Success',
    SUCCESSFUL: 'Successful',
    FAILED: 'Failed',
    IN_PROGRESS: 'In Progress',
    COMPLETED_WITH_WARNING: 'Completed with Warning',
    QUALIFIED_PERCENTAGE: 'Qualified Percentage',
    QUALIFIED_PERCENT_SYMBOL: 'Qualified %',
    BUSINESS_COMPONENTS: 'Import from Excel',
    NOTES: 'Notes',
    EMAIL_REMINDER_FREQUENCY: ['No reminders', 'Every 1 days', 'Every 2 days', 'Every 3 days', 'Every 4 days', 'Every 5 days',
        'Every 6 days', 'Every 7 days', 'Every 8 days', 'Every 9 days', 'Every 10 days'],
    PROJECT_OPTIONS: ['Process', 'Product', 'Software'],
    MANAGE_USERS: 'Manage Users',
    MANAGE_CLIENT_USERS: 'Manage Client Users',
    MANAGE_CLIENT: 'Manage Client',
    ADD_CLIENT: 'Add Client User',
    ADD_CLIENTADMIN_USER: 'Add User',
    ADD_BULK_CLIENT: 'Add Bulk Client User',
    ADD_CLIENTADMIN_BULK_CLIENT: 'Add Bulk User',
    ADD_PROJECT: 'Add Project',
    EDIT_SURVEY: 'Edit Survey',
    EDIT_SURVEY_ADD_PROJECT: 'Edit Survey -> Add Project',
    IMPORT_PROJECTS_ADD_PROJECT: 'Import Projects -> Add Project',
    NQA: 'NQA',
    NWT: 'NWT',
    UPLOAD_RELEASE_NOTES: 'Upload Latest Release Notes',
    UPLOAD_RELEASE_HISTORY: 'Upload Release History',
    UPLOAD_PAYROLL: 'Import Payroll',
    UPLOAD_PROJECTS: 'Import Projects',
    UPLOAD_EXPENSE_DATA: 'Import Expense Data',
    UPLOAD_TIME_TRACKING: 'Import Time Tracking',
    IMPORT_TIME_TRACKING: 'Import Time Tracking',
    UPLOAD_EXPENSE_SURVEY_DOCUMENT: 'Manage Files',
    UPLOAD_TIME_SURVEY_DOCUMENT: (employeeName: string) => employeeName && employeeName.length > 0 ? 'Import Document' + ' for ' + employeeName : 'Import Document',
    ADD_MULTIPLE_USERS: 'Add Multiple Users',
    EXPENSE_SURVEY: 'Expense Survey',
    TIME_SURVEY: 'Time Survey',
    PROJECT_SURVEY: 'Project Survey',
    QUALITATIVE_SURVEY: 'Qualitative Survey',
    RECONCILIATION_SURVEY: 'Reconciliation Survey',
    ADD_MULTIPLE_USERS_MESSAGE: 'All users imported successfully! It can take a few minutes for all users to get provisioned.',
    FAILED_MULTIPLE_USERS_MESSAGE: 'File uploaded succfully with errors.',
    FILE_UPLOAD_TYPES: ['.html', '.htm', '.ppt', '.pptx', '.txt', '.doc', '.docx', '.pdf', '.msg', '.zip', '.eml', '.odt', '.rtf', '.xls', '.xlsx', '.xlsm', '.csv'],
    FILE_NOT_SUPPORTED: 'File type not supported',
    VIEW_TIME_SURVEY_DOCUMENT: (employeeName: string) => employeeName && employeeName.length > 0 ? 'View Time Tracking Documents' + ' for ' + employeeName : 'View Time Tracking Documents',
    VIEW_EXPENSE_SURVEY_DOCUMENT: 'View Expense Survey Documents',
    VIEW_PROJECT_SURVEY_DOCUMENT: 'View Project Survey Documents',
    UPLOAD_PROJECT_SURVEY_DOCUMENT: 'Import Documents',
    LOCATIONS: ["AK", "AL", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "FM", "GA", "GU", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MH", "MI", "MN", "MO", "MP", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "PW", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"],
    COMMENTS: 'Comments',
    QUALIFIED_PERCENTAGE_COLUMN: 'QualifiedPercentage',
    PREVIEW_EMAIL_SUCCESS_MESSAGE: 'Email sent, please check your outlook inbox',
    SUBMIT_SURVEY_CONFIRMATION: "To the best of my knowledge and belief the information below is true and correct and relate to qualified activities in accordance with the requirements of IRC Section 41(d).",
    ASSIGNMENT_EMAIL: 'Initial Survey Assignment Email',
    EXPENSE_DATA_FILE_ERROR_MESSAGE: 'Error in Expense data file. Please fix the issues identified in the error file and import again.',
    PAYROLL_DATA_FILE_ERROR_MESSAGE: 'Error in Payroll data file. Please fix the issues identified in the error file and import again.',
    PROJECT_DATA_FILE_ERROR_MESSAGE: 'Error in Project data file. Please fix the issues identified in the error file and import again.',
    PAYROLL_DATA_ERROR: 'Payroll import completed with error',
    PAYROLL_DATA_WARNING: 'Payroll import completed with warning',
    PAYROLL_DATA_SUCCESS: 'Payroll import completed',
    PAYROLL_DATA_EXCEPTION: 'Payroll import completed with error',
    PROJECT_DATA_ERROR: 'Project import completed with error',
    PROJECT_DATA_WARNING: 'Project import completed with warning',
    PROJECT_DATA_SUCCESS: 'Project import completed',
    PROJECT_DATA_EXCEPTION: 'Project import completed with error',
    CLIENT_USER_RETRY_SUCCESS: 'Please wait a few minutes for the users to be provisioned and displayed on grid.',
    EMAIL_FAILED: 'Email failed to go',
    EMAIL_QUEUE: 'Email in Queue',
    STUDY_SETUP_HELP_TEXT: `Use this option if you need help from the Ignition coaches for the following: 
         - Using RCN for the first time and need assistance in setting up your study
         - Help configuring your RCN study to meet your client needs
         - Assistance transforming/ automating PBC data into the RCN import format. 
         - Learn more on best practices for YoY, sec. 174, etc.
         - Local calculation WP automation.
         - Have a feature request to improve the capabilities of RCN.`,
    TECHNICAL_SUPPORT_HELP_TEXT: `Use this option if you need help in the following:
        - You are running into an error or delay in processing while using RCN.`,
    MANAGE_FILES: 'Manage Files',
    BC__ERROR: 'Business Components import completed with errors',
    BC__WARNING: 'Business Components import completed with warnings',
    BC__SUCCESS: 'Business Components import completed',
}

export enum EMAIL_TEMPLATE_TYPE {
    ASSIGNMENT_EMAIL = 1,
    REMINDER_EMAIL = 2
}

export const LAST_UPDATED_BY_HEADER_TOOLTIP = {
    TIME_SURVEY: `Last Updated column shows the last date when any of the following activities were done in a Time Survey: 
        Survey Allocation Change, Survey Submit, Survey Details Update, Add/Remove Projects, Add/Remove Activities,
        Add/Remove Employees, Assign SME, Add Comment`,
    EXPENSE_SURVEY: `Last Updated column shows the last date when any of the following activities were done in an Expense Survey: 
        Edit Table Value, Survey Submit, Survey Details Update`,
    PROJECT_SURVEY: `Last Updated column shows the last date when any of the following activities were done in a Project Survey: 
        Edit Answer, Survey Submit, Survey Details Update, Assign SME`
}

export const EXPENSE_DATA_MAP_ERROR = {
    PROJECT_MAPPING_ERROR: `This project is not available in the study, review the projects in the Projects worksheet.`,
    LOCATION_MAPPING_ERROR: `This location is incorrect, please review the Standard Locations worksheet.`,
    QRE_TYPE_MAPPING_ERROR: `This is not a valid QRE Type, please review the QRE Types worksheet.`
}

export const SURVEY_STATUS_CONSTANTS = {
    UNASSIGNED: 'UNASSIGNED',
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN PROGRESS',
    COMPLETED: 'COMPLETED',
    UNPUBLISHED: 'UNPUBLISGED',
    SUBMITTED_WITH_WARNING: 'SUBMITTED WITH WARNING'
}

export const SURVEY_STATUS = {
    UNASSIGNED: 1,
    ASSIGNED: 2,
    IN_PROGRESS: 3,
    COMPLETED: 4,
    UN_PUBLISHED: 5,
    SUBMITTED_WITH_WARNING: 6
}

export const APP_ERROR_CODES = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    INTERNAL_SERVER_ERROR: 500,
    NOT_FOUND: 404,
    BAD_REQUEST: 400
};

export const SELECT_ALL_CHECKBOX = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
}

export const APP_ERROR_CONSTANTS = {
    BAD_REQUEST: 'Bad Request',
    UNAUTHORIZED_USER: 'User is not authorized',
    UNAUTHORIZED_ACCESS: 'Access to resource is not authorized',
    FORBIDDEN: "You don't have access to this study",
    RESOURCE_NOT_FOUND: 'Unable to locate resource',
    FORBIDDEN_USER: 'You do not have access to RCN. Please contact an engagement team member who has access to RCN or the application support team by clicking the envelope icon on the top right corner of your screen.',
    SYSTEM_ERROR: 'An error has occurred, please try again. If you continue to encounter this issue, please contact the application support team by clicking the envelope icon on the top right corner of your screen.'
};

export const EXPENSE_SURVEY_CONSTANTS = {
    MATCH_COLUMNS: 'Match Columns',
    SELECT_REORDER_COLUMNS: 'Select and Reorder Columns',
    SELECT_SURVEY_METHODS: 'Select Survey Methods',
    EXPENSE_DATA_FILE_ERROR_MESSAGE: 'Error in Expense data file. Please fix the issues identified in the error file and import again.',
    EXPENSE_DATA_FILE_WARNING_MESSAGE: 'Warnings in Expense data file. Import is completed but please review the warning file and import again if needed.',
    CANCEL_SURVEY_CREATION: 'Are you sure you want to cancel creation of the new survey?',
    PROJECT_TOOLTIP: `This is to map client projects to business components in the study. If the projects in the mapped PBC columns are not business components created in the data import section of the study, the project will not appear in the survey. Project should be identified as a business component first before mapping client data.`,
    QRE_TYPE_TOOLTIP: `Acceptable values include: 'Supply', 'Contract Research', 'Rental or Lease Costs of Computers', 'Utility', 'Qualified Energy Research', 'Consortium'. Any other value in the PBC column will be ignored.`,
    QUALIFIED_PERCENTAGE_TOOLTIP: `Values must be between 0 and 100. Any other value in the PBC column will be ignored.`,
    SME_TOOLTIP: `Client subject matter expert who will complete the survey.`,
    COST_CENTER_TOOLTIP: `If a PBC column is mapped, you can view survey results in the insights and QRE reports.`,
    NOTES_TOOLTIP: 'If a PBC column is mapped, you can see them under the Notes column in the survey.',
    LOCATION_TOOLTIP: `Acceptable values are 2 digit code or full name of the US States/Territory and 'International'. Any other value in the PBC column will be ignored.`
};

export const MANAGE_CLIENT_ADMIN_USER = {
    GUIDANCE_TOOLTIP: `<p>If you want a client user to setup and administer a study (import data, spin-up surveys and other study setup and administrative activities), select the box next to the user. This is typically for client engagements where the client has agreed to administer and manage the study themselves.</p>
    <p>This is different from the 'Client Manager' role that gives access to the survey list, dashboards etc. for oversight into the study. This would typically be users in the Tax Director or VP role. You can add users to the 'Client Manager' role from the 'Edit Study' form within the study.</p>
    <p>If you have questions, please contact the application support team by clicking the envelope icon on the top right corner of your screen.</p>`,
    GUIDANCE_TOOLTIP_CLIENT_MANAGER: `<p>Check this box if you want a client user to have access to the survey list, documents and dashboards for oversight into the study. They will be managers ONLY for this study. 'Client Manager' role would typically be folks in the Tax Director or VP role..</p>`,
    GUIDANCE_TOOLTIP_CLIENT_ADMIN: `<p>Check this box if you want a client user to setup and administer a study (import data, spin-up surveys and other study setup and administrative activity). They will be admins for all studies under this client. This is typically for client engagements where the client has agreed to administer and manage the study themselves. Please email the Support Mailbox if you have questions.</p>`,
    GUIDANCE_TOOLTIP_KPMG_USER: `Trouble looking up a new KPMG associate? They might not be added to RCN.
    <br/> <br/>
    Go to 'Settings' > 'Manage KPMG Users' and use the '+Add KPMG User' option to add them to RCN and then look them up again in the study's 'access & permissions' screen and add them.
    `,
};

export const MESSAGE_EMAILFAILURE = {
    EMAILFAILURE_MESSAGE: `Emails have failed to go out in the past 2 days. Please review the Email report under the Reports page.`
};

export const BULK_ACTION_TYPES = {
    ADD: 'Add',
    EDIT_DATE: 'Edit Date'
};

export const EMAIL_INITIAL_ASSIGNMENT = {
    GUIDANCE_TOOLTIP: `To insert a table in the email, first prepare the table in MS Word and then copy and paste the table into the email body below`
}
export const EMAIL_LINK = {
    LINK_GUIDANCE_TOOLTIP: `The SMEs must be accessing the Navigator using the link - https://rcnsurvey.apps.kpmgservices.tech. Please confirm this before sending out the emails`
}
export const RETRY_COUNT: number = 10;
export const RETRY_COUNT_LARGE: number = 84;
export const NO_OF_RECORDS: number = 5000;
export const RETRY_INTERVAL: number = 5000;
export const RETRY_INTERVAL_LARGE: number = 10000;

export const DOMAIN_WHITELIST = [
    "kpmg.com",
    "gdc-kpmg.com",
    "test-kpmg.com"
]

export const ACTIVITY_CONSTANTS = {
    ACTIVITY: 'Activity',
    NQA: 'NQA',
    OQP: 'OQP',
    PROJECT: 'Project',
    NWT: 'NWT'
}

export const ACTIVITY_SUBTYPE_CONSTANTS = {
    QUALIFIEDDIRECTRESEARCH: 'Qualified Direct Research - POE',
    QUALIFIEDDIRECTRESEARCHNONPOE: 'Qualified Direct Research - Non-POE',
    QUALIFIEDDIRECTSUPERVISION: 'Qualified Direct Supervision - POE',
    QUALIFIEDDIRECTSUPERVISIONNONPOE: 'Qualified Direct Supervision - Non-POE',
    QUALIFIEDFIRECTSUPPORT: 'Qualified Direct Support - POE',
    QUALIFIEDFIRECTSUPPORTNONPOE: 'Qualified Direct Support - Non-POE',
    NONQUALIFIED: 'Non-qualified',
    NQ41Q174: 'NQ41/Q174',
    NONWORKINGTIME: 'Non-working Time'
}

export const ACTIVITY_SUBTYPES_CONSTANTS_FILTER =
    `${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCH},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCHNONPOE},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISION},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISIONNONPOE},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORT},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORTNONPOE},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.NONQUALIFIED},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174},
                         ${ACTIVITY_SUBTYPE_CONSTANTS.NONWORKINGTIME}`;

export const ACTIVITYSUBTYPES = [
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Support - POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORT },
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Support - Non-POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORTNONPOE },
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Supervision - POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISION },
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Supervision - Non-POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISIONNONPOE },
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Research - POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCH },
    { activitySubType: ActivitySubTypeEnum['Qualified Direct Research - Non-POE'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCHNONPOE },
    { activitySubType: ActivitySubTypeEnum['Non-qualified'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.NONQUALIFIED },
    { activitySubType: ActivitySubTypeEnum['NQ41/Q174'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174 },
    { activitySubType: ActivitySubTypeEnum['Non-working Time'], activitySubTypeName: ACTIVITY_SUBTYPE_CONSTANTS.NONWORKINGTIME },
];


export const ACTIVITY_FILTER_COLUMNS: FilterState[] = [
    { filterColumn: 'ACTIVITY NAME', filterOptions: null, isFilterApplied: false, filterType: FilterType.TextFilter, searchtext: '' },
    {
        filterColumn: 'ACTIVITY TYPE', filterOptions: [
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCH, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTRESEARCHNONPOE, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISION, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDDIRECTSUPERVISIONNONPOE, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORT, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.QUALIFIEDFIRECTSUPPORTNONPOE, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.NONQUALIFIED, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.NQ41Q174, isSelected: true },
            { optionName: ACTIVITY_SUBTYPE_CONSTANTS.NONWORKINGTIME, isSelected: true }
        ], isFilterApplied: false, searchtext: null, filterType: FilterType.MultipleSelectFilter
    },
    {
        filterColumn: 'MASTER ACTIVITY', filterOptions: [
            { optionName: 'Yes', isSelected: true },
            { optionName: 'No', isSelected: true }
        ], isFilterApplied: false, searchtext: null, filterType: FilterType.MultipleSelectFilter
    }
];

export const Modal_Constants =
{
    BUSINESSCOMPGUIDE: 'businessCompGuide-modal',
    CREATENEWCLIENTPROJECT: 'create-new-project-modal',
    DELETEBUSINESSCOMPONENT: 'delete-biz-comp-modal',
    ADDEXISTINGCLIENTPROJECT: 'add-client-proj-modal',
    CREATENEWBUSINESSCOMPONENT: 'create-new-bc-modal',
    ADDTOBUSINESSCOMPONENT: 'add-to-business-component',
    EDITCLIENTPROJECT: 'edit-client-project-modal',
    UPDATEQUALIFIEDPERCENTAGE: 'update-qualified-percentage'
}

export enum BUSINESSCOMPONENTTYPE {
    BUSINESSCOMPONENT = 1,
    CLIENTPROJECT = 2
}

export enum SearchStudyOption {
    client = 1, study = 2
}

export const StudySearchBy = [
    { optionId: 1, optionName: 'Client', isSelected: false },
    { optionId: 2, optionName: 'Study', isSelected: false }
]
